import React, { useState } from "react";
import { AlertIcon } from "./icons/alert";

const EmailInput = ({ onChange, name }) => {
    const emailRegex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    const [emailvalue, setEmail] = useState("");
    const [hasError, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    return (
        <div className={`zds-form-item ${hasError ? "zds-form-item-error" : ""}`}>
            <label htmlFor={name} className="zds-form-label zds-form-label-large">
              Username (Email) <span className="zds-form-label-required">*</span>
            </label>
            <input
              type="text"
              value={emailvalue}
              onChange={(event) => {
                const value = event.target.value;
                if (value.trim() === "" || !emailRegex.test(value)) {
                    setError(true);
                    setErrorMessage("Email is Required.");
                    setEmail(value);
                    onChange("");
                    return;
                }
                setError(false);
                setEmail(value);
                onChange(value);
              }}
              id={name}
              className="zds-input-textfield zds-input-textfield-large"
              autoFocus=""
            />
            {hasError && (
                <p className="zds-form-instructions zds-form-instructions-large">
                    <AlertIcon /> {errorMessage}
                </p>
            )}
        </div>
    );
};

export default EmailInput;